import { ITEM_DEFINITION_CODES } from '../../constants';

export const features = [
  {
    code: ITEM_DEFINITION_CODES.FORWARD_MAIL,
    icon: 'mail',
    title: 'Forward<br/>Mail',
  },
  {
    code: ITEM_DEFINITION_CODES.UPDATE_ACCOUNT,
    icon: 'accounts',
    title: 'Update<br/>Accounts',
  },
  {
    code: ITEM_DEFINITION_CODES.UTILITY,
    icon: 'utilities',
    title: 'Contact<br/>Utilities',
  },
  {
    code: ITEM_DEFINITION_CODES.HOME_SERVICE,
    icon: 'connect',
    title: 'Hook Up<br/>TV & Internet',
  },
  {
    code: ITEM_DEFINITION_CODES.OFFER,
    icon: 'deals',
    title: 'Search<br/>Move-In Offers',
  },
  {
    code: ITEM_DEFINITION_CODES.SHARE,
    icon: 'share',
    title: 'Share Your<br/>New Address',
  },
];
